const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/insights/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { PROGRESS_TIMEFRAME_VALUES } from '@/components/insights/progress/progressTimeframe';
import { INSIGHTS_SORT_DIRECTIONS, INSIGHTS_SORTABLE_FIELDS } from '@/lib/api/types/insights/sorting';
import { compactDateFilterSchema, compactPicklistFilterSchema } from '@/lib/zod-schemas/common/compactFilterSchemas';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';

/**
 * Validates compact groupBy format: groupBy1 or groupBy1_groupBy2
 * Examples: team, plan, team_plan, plan_itemType
 */
const compactGroupBySchema = z.string().regex(/^(team|plan|itemType|integration)(_(?:team|plan|itemType|integration))?$/, 'Invalid groupBy format. Expected: groupBy or groupBy1_groupBy2 (e.g., team, plan, team_plan)').optional();
export const insightsSearchSchema = z.object({
  insightId: z.preprocess(v => v === '' || v === undefined ? undefined : Number(v), z.number().int().positive()).optional(),
  scopeItemId: z.preprocess(v => v === '' || v === undefined ? undefined : Number(v), z.number().int().positive()).optional(),
  planId: compactPicklistFilterSchema,
  teamId: compactPicklistFilterSchema,
  statusId: compactPicklistFilterSchema,
  itemTypeId: compactPicklistFilterSchema,
  integrationId: compactPicklistFilterSchema,
  expectedStartDateTime: compactDateFilterSchema,
  expectedFinishDateTime: compactDateFilterSchema,
  latestFinishDateTime: compactDateFilterSchema,
  orderBy: z.enum(INSIGHTS_SORTABLE_FIELDS).optional(),
  orderDir: z.enum(INSIGHTS_SORT_DIRECTIONS).optional(),
  groupBy: compactGroupBySchema,
  progressTimeframe: z.enum(PROGRESS_TIMEFRAME_VALUES).optional()
});
export const insightsDeliverablesSearchSchema = insightsSearchSchema.and(itemPanelSearchSchema);
export const Route = createFileRoute('/(app)/org/$org/insights')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(insightsDeliverablesSearchSchema)
});